<template lang="html">
  <div :style="image" class="gallery-image"></div>
</template>

<script>
export default {
  name: 'gallery-image',

  props: {
    content: String
  },

  computed: {
    image() {
      return `background-image: url('${this.content}')`
    }
  }
}
</script>

<style lang="sass">
  .gallery-image
    max-width: 100%
    height: 250px
    background-size: cover
    background-position: 50% 50%
</style>
